// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetEmailSettingsResponse

export type WidgetEmailSettingsApiResponse = {
	showLogo: boolean;
	headerText: string;
	footerText: string;
	customContent: Record<string, string>;
	banner: string;
	logo: string;
};

export type WidgetEmailSettings = {
	showLogo: boolean;
	headerText: string;
	footerText: string;
	customContent: Record<string, string>;
	banner: string;
	logo: string;
};

export function hydrateWidgetEmailSettings(data: WidgetEmailSettingsApiResponse): WidgetEmailSettings {
	return {
		...data,
		customContent: Array.isArray(data.customContent) ? {} : data.customContent,
	};
}